var _defs, _rect, _g, _g2, _tspan, _g3, _tspan2, _g4, _tspan3, _g5, _tspan4, _g6, _tspan5, _g7, _tspan6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKpScale2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1816.918,
    height: 108.339,
    viewBox: "0 0 1816.918 108.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 1,
    cy: 0.5,
    r: 266,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1915",
    "data-name": "Rectangle 1915",
    width: 231.946,
    height: 2.997,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5181",
    "data-name": "Group 5181",
    transform: "translate(-1460.413 -955.428)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 1696.855,
    height: 2.997,
    transform: "translate(1580.477 984.274)",
    fill: "url(#radial-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5179",
    "data-name": "Group 5179",
    transform: "translate(1460.413 984.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5158",
    "data-name": "Group 5158",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_3",
    "data-name": "Repeat Grid 3",
    transform: "translate(-31.745 0.049)",
    opacity: 0.253
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5114",
    "data-name": "Group 5114"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5115",
    "data-name": "Group 5115",
    transform: "translate(5.37)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-2",
    "data-name": "Line 1-2",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2",
    "data-name": "Line 2-2",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-2",
    "data-name": "Line 3-2",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5116",
    "data-name": "Group 5116",
    transform: "translate(10.74)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-3",
    "data-name": "Line 1-3",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-3",
    "data-name": "Line 2-3",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-3",
    "data-name": "Line 3-3",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5117",
    "data-name": "Group 5117",
    transform: "translate(16.11)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-4",
    "data-name": "Line 1-4",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-4",
    "data-name": "Line 2-4",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-4",
    "data-name": "Line 3-4",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5118",
    "data-name": "Group 5118",
    transform: "translate(21.48)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-5",
    "data-name": "Line 1-5",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-5",
    "data-name": "Line 2-5",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-5",
    "data-name": "Line 3-5",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5119",
    "data-name": "Group 5119",
    transform: "translate(26.85)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-6",
    "data-name": "Line 1-6",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-6",
    "data-name": "Line 2-6",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-6",
    "data-name": "Line 3-6",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5120",
    "data-name": "Group 5120",
    transform: "translate(32.22)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-7",
    "data-name": "Line 1-7",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-7",
    "data-name": "Line 2-7",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-7",
    "data-name": "Line 3-7",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5121",
    "data-name": "Group 5121",
    transform: "translate(37.59)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-8",
    "data-name": "Line 1-8",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-8",
    "data-name": "Line 2-8",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-8",
    "data-name": "Line 3-8",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5122",
    "data-name": "Group 5122",
    transform: "translate(42.96)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-9",
    "data-name": "Line 1-9",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-9",
    "data-name": "Line 2-9",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-9",
    "data-name": "Line 3-9",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5123",
    "data-name": "Group 5123",
    transform: "translate(48.33)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-10",
    "data-name": "Line 1-10",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-10",
    "data-name": "Line 2-10",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-10",
    "data-name": "Line 3-10",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5124",
    "data-name": "Group 5124",
    transform: "translate(53.7)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-11",
    "data-name": "Line 1-11",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-11",
    "data-name": "Line 2-11",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-11",
    "data-name": "Line 3-11",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5125",
    "data-name": "Group 5125",
    transform: "translate(59.07)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-12",
    "data-name": "Line 1-12",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-12",
    "data-name": "Line 2-12",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-12",
    "data-name": "Line 3-12",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5126",
    "data-name": "Group 5126",
    transform: "translate(64.44)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-13",
    "data-name": "Line 1-13",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-13",
    "data-name": "Line 2-13",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-13",
    "data-name": "Line 3-13",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5127",
    "data-name": "Group 5127",
    transform: "translate(69.81)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-14",
    "data-name": "Line 1-14",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-14",
    "data-name": "Line 2-14",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-14",
    "data-name": "Line 3-14",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5128",
    "data-name": "Group 5128",
    transform: "translate(75.18)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-15",
    "data-name": "Line 1-15",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-15",
    "data-name": "Line 2-15",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-15",
    "data-name": "Line 3-15",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5129",
    "data-name": "Group 5129",
    transform: "translate(80.55)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-16",
    "data-name": "Line 1-16",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-16",
    "data-name": "Line 2-16",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-16",
    "data-name": "Line 3-16",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5130",
    "data-name": "Group 5130",
    transform: "translate(85.92)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-17",
    "data-name": "Line 1-17",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-17",
    "data-name": "Line 2-17",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-17",
    "data-name": "Line 3-17",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5131",
    "data-name": "Group 5131",
    transform: "translate(91.29)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-18",
    "data-name": "Line 1-18",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-18",
    "data-name": "Line 2-18",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-18",
    "data-name": "Line 3-18",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5132",
    "data-name": "Group 5132",
    transform: "translate(96.661)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-19",
    "data-name": "Line 1-19",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-19",
    "data-name": "Line 2-19",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-19",
    "data-name": "Line 3-19",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5133",
    "data-name": "Group 5133",
    transform: "translate(102.031)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-20",
    "data-name": "Line 1-20",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-20",
    "data-name": "Line 2-20",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-20",
    "data-name": "Line 3-20",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5134",
    "data-name": "Group 5134",
    transform: "translate(107.401)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-21",
    "data-name": "Line 1-21",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-21",
    "data-name": "Line 2-21",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-21",
    "data-name": "Line 3-21",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5135",
    "data-name": "Group 5135",
    transform: "translate(112.771)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-22",
    "data-name": "Line 1-22",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-22",
    "data-name": "Line 2-22",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-22",
    "data-name": "Line 3-22",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5136",
    "data-name": "Group 5136",
    transform: "translate(118.141)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-23",
    "data-name": "Line 1-23",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-23",
    "data-name": "Line 2-23",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-23",
    "data-name": "Line 3-23",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5137",
    "data-name": "Group 5137",
    transform: "translate(123.511)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-24",
    "data-name": "Line 1-24",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-24",
    "data-name": "Line 2-24",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-24",
    "data-name": "Line 3-24",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5138",
    "data-name": "Group 5138",
    transform: "translate(128.881)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-25",
    "data-name": "Line 1-25",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-25",
    "data-name": "Line 2-25",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-25",
    "data-name": "Line 3-25",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5139",
    "data-name": "Group 5139",
    transform: "translate(134.251)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-26",
    "data-name": "Line 1-26",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-26",
    "data-name": "Line 2-26",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-26",
    "data-name": "Line 3-26",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5140",
    "data-name": "Group 5140",
    transform: "translate(139.621)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-27",
    "data-name": "Line 1-27",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-27",
    "data-name": "Line 2-27",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-27",
    "data-name": "Line 3-27",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5141",
    "data-name": "Group 5141",
    transform: "translate(144.991)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-28",
    "data-name": "Line 1-28",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-28",
    "data-name": "Line 2-28",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-28",
    "data-name": "Line 3-28",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5142",
    "data-name": "Group 5142",
    transform: "translate(150.361)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-29",
    "data-name": "Line 1-29",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-29",
    "data-name": "Line 2-29",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-29",
    "data-name": "Line 3-29",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5143",
    "data-name": "Group 5143",
    transform: "translate(155.731)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-30",
    "data-name": "Line 1-30",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-30",
    "data-name": "Line 2-30",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-30",
    "data-name": "Line 3-30",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5144",
    "data-name": "Group 5144",
    transform: "translate(161.101)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-31",
    "data-name": "Line 1-31",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-31",
    "data-name": "Line 2-31",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-31",
    "data-name": "Line 3-31",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5145",
    "data-name": "Group 5145",
    transform: "translate(166.471)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-32",
    "data-name": "Line 1-32",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-32",
    "data-name": "Line 2-32",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-32",
    "data-name": "Line 3-32",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5146",
    "data-name": "Group 5146",
    transform: "translate(171.841)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-33",
    "data-name": "Line 1-33",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-33",
    "data-name": "Line 2-33",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-33",
    "data-name": "Line 3-33",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5147",
    "data-name": "Group 5147",
    transform: "translate(177.211)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-34",
    "data-name": "Line 1-34",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-34",
    "data-name": "Line 2-34",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-34",
    "data-name": "Line 3-34",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5148",
    "data-name": "Group 5148",
    transform: "translate(182.581)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-35",
    "data-name": "Line 1-35",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-35",
    "data-name": "Line 2-35",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-35",
    "data-name": "Line 3-35",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5149",
    "data-name": "Group 5149",
    transform: "translate(187.951)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-36",
    "data-name": "Line 1-36",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-36",
    "data-name": "Line 2-36",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-36",
    "data-name": "Line 3-36",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5150",
    "data-name": "Group 5150",
    transform: "translate(193.321)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-37",
    "data-name": "Line 1-37",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-37",
    "data-name": "Line 2-37",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-37",
    "data-name": "Line 3-37",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5151",
    "data-name": "Group 5151",
    transform: "translate(198.691)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-38",
    "data-name": "Line 1-38",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-38",
    "data-name": "Line 2-38",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-38",
    "data-name": "Line 3-38",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5152",
    "data-name": "Group 5152",
    transform: "translate(204.061)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-39",
    "data-name": "Line 1-39",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-39",
    "data-name": "Line 2-39",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-39",
    "data-name": "Line 3-39",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5153",
    "data-name": "Group 5153",
    transform: "translate(209.431)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-40",
    "data-name": "Line 1-40",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-40",
    "data-name": "Line 2-40",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-40",
    "data-name": "Line 3-40",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5154",
    "data-name": "Group 5154",
    transform: "translate(214.801)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-41",
    "data-name": "Line 1-41",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-41",
    "data-name": "Line 2-41",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-41",
    "data-name": "Line 3-41",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5155",
    "data-name": "Group 5155",
    transform: "translate(220.171)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-42",
    "data-name": "Line 1-42",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-42",
    "data-name": "Line 2-42",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-42",
    "data-name": "Line 3-42",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5156",
    "data-name": "Group 5156",
    transform: "translate(225.541)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-43",
    "data-name": "Line 1-43",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-43",
    "data-name": "Line 2-43",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-43",
    "data-name": "Line 3-43",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5157",
    "data-name": "Group 5157",
    transform: "translate(230.911)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-44",
    "data-name": "Line 1-44",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(32.22)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-44",
    "data-name": "Line 2-44",
    x1: 40.275,
    y2: 4.112,
    transform: "translate(8.055)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-44",
    "data-name": "Line 3-44",
    x1: 40.275,
    y2: 4.112,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.924
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5176",
    "data-name": "Group 5176",
    transform: "translate(-57.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5175",
    "data-name": "Group 5175",
    transform: "translate(47.725)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_9",
    "data-name": "Path 9",
    transform: "translate(3097 955.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M2457.275,864.535a27.041,27.041,0,1,1,10.557-2.131A26.955,26.955,0,0,1,2457.275,864.535Z",
    transform: "translate(-2429.152 -809.289)",
    fill: "#790000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M2457.35,811.361a26.034,26.034,0,1,0,10.168,2.053,25.959,25.959,0,0,0-10.168-2.053m0-2a28.122,28.122,0,1,1-28.123,28.122A28.122,28.122,0,0,1,2457.35,809.364Z",
    transform: "translate(-2429.227 -809.364)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Kp_9o",
    "data-name": "Kp 9o",
    transform: "translate(3062 1025.767)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "Kp_9",
    "data-name": "Kp > = 9",
    transform: "translate(0 31)",
    fill: "#fff",
    fontSize: 33,
    fontFamily: "HelveticaNeue, Helvetica Neue",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Kp &gt; = 9"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5174",
    "data-name": "Group 5174",
    transform: "translate(55.725)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Path_9-2",
    "data-name": "Path 9-2",
    transform: "translate(2784 955.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M2172.114,864.535a27.041,27.041,0,1,1,10.558-2.131A26.954,26.954,0,0,1,2172.114,864.535Z",
    transform: "translate(-2143.992 -809.289)",
    fill: "#ff0402"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M2172.189,811.361a26.037,26.037,0,1,0,10.168,2.053,25.959,25.959,0,0,0-10.168-2.053m0-2a28.122,28.122,0,1,1-28.122,28.122A28.122,28.122,0,0,1,2172.189,809.364Z",
    transform: "translate(-2144.067 -809.364)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Kp_8_9",
    "data-name": "Kp 8 9",
    transform: "translate(2751 1025.849)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "Kp_8",
    "data-name": "Kp > = 8",
    transform: "translate(0 30)",
    fill: "#fff",
    fontSize: 32,
    fontFamily: "HelveticaNeue, Helvetica Neue",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Kp &gt; = 8"))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5173",
    "data-name": "Group 5173",
    transform: "translate(34.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(2464.743 956.306)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    transform: "translate(36)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_344",
    "data-name": "Ellipse 344",
    cx: 27.968,
    cy: 27.469,
    rx: 27.968,
    ry: 27.469,
    fill: "#f76400"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_345",
    "data-name": "Ellipse 345",
    cx: 26.969,
    cy: 26.47,
    rx: 26.969,
    ry: 26.47,
    transform: "translate(0.999 0.999)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.848
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Kp_7",
    "data-name": "Kp 7",
    transform: "translate(0 69.461)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "Kp_7-2",
    "data-name": "Kp > = 7",
    transform: "translate(0 31)",
    fill: "#fff",
    fontSize: 33,
    fontFamily: "HelveticaNeue, Helvetica Neue",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Kp &gt; = 7")))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5172",
    "data-name": "Group 5172",
    transform: "translate(13.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(2179.072 956.306)"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3-2",
    "data-name": "Ellipse 3-2",
    transform: "translate(35)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_346",
    "data-name": "Ellipse 346",
    cx: 28.467,
    cy: 27.469,
    rx: 28.467,
    ry: 27.469,
    fill: "#f8bc00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_347",
    "data-name": "Ellipse 347",
    cx: 27.469,
    cy: 26.47,
    rx: 27.469,
    ry: 26.47,
    transform: "translate(0.999 0.999)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.848
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Kp_6",
    "data-name": "Kp 6",
    transform: "translate(0 69.461)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "Kp_6-2",
    "data-name": "Kp > = 6",
    transform: "translate(0 31)",
    fill: "#fff",
    fontSize: 33,
    fontFamily: "HelveticaNeue, Helvetica Neue",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Kp &gt; = 6")))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5171",
    "data-name": "Group 5171",
    transform: "translate(-8.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(1894.394 956.306)"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3-3",
    "data-name": "Ellipse 3-3",
    transform: "translate(36)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_348",
    "data-name": "Ellipse 348",
    cx: 27.968,
    cy: 27.469,
    rx: 27.968,
    ry: 27.469,
    fill: "#f6eb14"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_349",
    "data-name": "Ellipse 349",
    cx: 26.969,
    cy: 26.47,
    rx: 26.969,
    ry: 26.47,
    transform: "translate(0.999 0.999)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.848
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Kp_5",
    "data-name": "Kp 5",
    transform: "translate(0 69.461)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "Kp_5-2",
    "data-name": "Kp > = 5",
    transform: "translate(0 31)",
    fill: "#fff",
    fontSize: 33,
    fontFamily: "HelveticaNeue, Helvetica Neue",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Kp &gt; = 5")))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5170",
    "data-name": "Group 5170"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(1629.22 956.306)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_350",
    "data-name": "Ellipse 350",
    cx: 27.968,
    cy: 27.469,
    rx: 27.968,
    ry: 27.469,
    fill: "#92d050"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_351",
    "data-name": "Ellipse 351",
    cx: 26.969,
    cy: 26.47,
    rx: 26.969,
    ry: 26.47,
    transform: "translate(0.999 0.999)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.848
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Kp_5-2-2",
    "data-name": "Kp 5-2",
    transform: "translate(1607.725 1025.767)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "Kp_5-3",
    "data-name": "Kp < 5",
    transform: "translate(0 31)",
    fill: "#fff",
    fontSize: 33,
    fontFamily: "HelveticaNeue, Helvetica Neue",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Kp &lt; 5"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpScale2);
export default __webpack_public_path__ + "static/media/kp_scale2.d4a913c7524b3115549e267ffe49d795.svg";
export { ForwardRef as ReactComponent };